// import { createApi } from '@reduxjs/toolkit/query/react';
// import { baseQueryWithReauth } from '../../api';
// import {
//   IStoreDetails,
//   IStoreId,
//   IStoreReview,
//   IUpdateStoreReview,
//   ITemplate,
//   ITemplatesResponse,
//   IProp,
//   IPropsResponse,
//   IPropsQueryParams,
//   IUpdateStorePayload,
//   IUpdateStore
// } from './interface';

// export const storesApi = createApi({
//   reducerPath: 'storesApi',
//   baseQuery: baseQueryWithReauth,
//   tagTypes: ['Stores', 'Props'],
//   endpoints: (builder) => ({
//     createStore: builder.mutation<IStoreDetails, FormData>({
//       query: (formData) => ({
//         url: `/stores/`,
//         method: 'POST',
//         body: formData,
//       }),
//       invalidatesTags: ['Stores'],
//     }),

//     createStoreReview: builder.mutation<'', IStoreReview>({
//       query: (body) => ({
//         url: `/store-reviews/`,
//         method: 'POST',
//         body,
//       }),
//     }),

//     getStoreReview: builder.query<IStoreReview, string>({
//       query: (reviewId) => ({
//         url: `/store-reviews/${reviewId}`,
//         method: 'GET',
//       }),
//     }),

//     updateStoreReview: builder.mutation<IStoreReview, { reviewId: string; body: IUpdateStoreReview }>({
//       query: ({ reviewId, body }) => ({
//         url: `/store-reviews/${reviewId}`,
//         method: 'PUT',
//         body,
//       }),
//     }),

//     getReviewsByStore: builder.query<IStoreReview[], string>({
//       query: (storeId) => ({
//         url: `/store-reviews/store/${storeId}`,
//         method: 'GET',
//       }),
//     }),

//     getStoresList: builder.query<IStoreDetails[], void>({
//       query: () => ({
//         url: `/stores/`,
//         method: 'GET',
//       }),
//     }),

//     getStoreByOwner: builder.query<IStoreDetails[], void>({
//       query: () => ({
//         url: `/stores/owner`,
//         method: 'GET',
//       }),
//     }),

//     deleteStoreReview: builder.mutation<void, string>({
//       query: (reviewId) => ({
//         url: `/store-reviews/${reviewId}`,
//         method: 'DELETE',
//       }),
//     }),

//     getTemplates: builder.query<ITemplatesResponse, { page?: number; limit?: number }>({
//       query: ({ page = 1, limit = 10 } = {}) => ({
//         url: `/stores/templates/`,
//         method: 'GET',
//         params: { page, limit },
//       }),
//     }),

//     getTemplateById: builder.query<ITemplate, string>({
//       query: (templateId) => ({
//         url: `/stores/templates/${templateId}`,
//         method: 'GET',
//       }),
//     }),

//     getProps: builder.query<IPropsResponse, IPropsQueryParams>({
//       query: ({ page = 1, limit = 10 } = {}) => ({
//         url: `/stores/props/`,
//         method: 'GET',
//         params: { page, limit },
//       }),
//       providesTags: ['Props'],
//     }),

//     updateStore: builder.mutation<IStoreDetails, { storeId: string; payload: IUpdateStore }>({
//       query: ({ storeId, payload }) => ({
//         url: `/stores/${storeId}`,
//         method: 'PUT',
//         body: payload,
//       }),
//       invalidatesTags: ['Stores'],
//     }),

//     getStoreById: builder.query<IStoreDetails, string>({
//       query: (storeId) => ({
//         url: `/stores/${storeId}`,
//         method: 'GET',
//       }),
//       providesTags: ['Stores'],
//     }),
//   }),
// });

// export const {
//   useCreateStoreMutation,
//   useCreateStoreReviewMutation,
//   useGetStoreReviewQuery,
//   useUpdateStoreReviewMutation,
//   useGetReviewsByStoreQuery,
//   useDeleteStoreReviewMutation,
//   useGetStoresListQuery,
//   useGetStoreByOwnerQuery,
//   useGetTemplatesQuery,
//   useGetTemplateByIdQuery,
//   useGetPropsQuery,
//   useUpdateStoreMutation,
//   useGetStoreByIdQuery,
// } = storesApi;





import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../api';
import {
  IStoreDetails,
  IStoreId,
  IStoreReview,
  IUpdateStoreReview,
  ITemplate,
  ITemplatesResponse,
  IProp,
  IPropsResponse,
  IPropsQueryParams,
  IUpdateStorePayload,
  IUpdateStore
} from './interface';

export const storesApi = createApi({
  reducerPath: 'storesApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Stores', 'Props'],
  endpoints: (builder) => ({
    createStore: builder.mutation<IStoreDetails, FormData>({
      query: (formData) => ({
        url: `/stores/`,
        method: 'POST',
        body: formData,
      }),
      invalidatesTags: ['Stores'],
    }),

    createStoreReview: builder.mutation<'', IStoreReview>({
      query: (body) => ({
        url: `/store-reviews/`,
        method: 'POST',
        body,
      }),
    }),

    getStoreReview: builder.query<IStoreReview, string>({
      query: (reviewId) => ({
        url: `/store-reviews/${reviewId}`,
        method: 'GET',
      }),
    }),

    updateStoreReview: builder.mutation<IStoreReview, { reviewId: string; body: IUpdateStoreReview }>({
      query: ({ reviewId, body }) => ({
        url: `/store-reviews/${reviewId}`,
        method: 'PUT',
        body,
      }),
    }),

    getReviewsByStore: builder.query<IStoreReview[], string>({
      query: (storeId) => ({
        url: `/store-reviews/store/${storeId}`,
        method: 'GET',
      }),
    }),

    getStoresList: builder.query<IStoreDetails[], void>({
      query: () => ({
        url: `/stores/`,
        method: 'GET',
      }),
      providesTags: ['Stores'],
    }),

    getStoreByOwner: builder.query<IStoreDetails[], void>({
      query: () => ({
        url: `/stores/owner`,
        method: 'GET',
      }),
      providesTags: ['Stores'],
    }),

    deleteStoreReview: builder.mutation<void, string>({
      query: (reviewId) => ({
        url: `/store-reviews/${reviewId}`,
        method: 'DELETE',
      }),
    }),

    getTemplates: builder.query<ITemplatesResponse, { page?: number; limit?: number }>({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: `/stores/templates/`,
        method: 'GET',
        params: { page, limit },
      }),
    }),

    getTemplateById: builder.query<ITemplate, string>({
      query: (templateId) => ({
        url: `/stores/templates/${templateId}`,
        method: 'GET',
      }),
    }),

    getProps: builder.query<IPropsResponse, IPropsQueryParams>({
      query: ({ page = 1, limit = 10 } = {}) => ({
        url: `/stores/props/`,
        method: 'GET',
        params: { page, limit },
      }),
      providesTags: ['Props'],
    }),

    // Fixed updateStore to accept FormData for logo uploads
    updateStore: builder.mutation<IStoreDetails, { storeId: string; payload: FormData | IUpdateStorePayload }>({
      query: ({ storeId, payload }) => ({
        url: `/stores/${storeId}`,
        method: 'PUT',
        body: payload,
      }),
      invalidatesTags: ['Stores'],
    }),

    getStoreById: builder.query<IStoreDetails, string>({
      query: (storeId) => ({
        url: `/stores/${storeId}`,
        method: 'GET',
      }),
      providesTags: ['Stores'],
    }),
  }),
});

export const {
  useCreateStoreMutation,
  useCreateStoreReviewMutation,
  useGetStoreReviewQuery,
  useUpdateStoreReviewMutation,
  useGetReviewsByStoreQuery,
  useDeleteStoreReviewMutation,
  useGetStoresListQuery,
  useGetStoreByOwnerQuery,
  useGetTemplatesQuery,
  useGetTemplateByIdQuery,
  useGetPropsQuery,
  useUpdateStoreMutation,
  useGetStoreByIdQuery,
} = storesApi;